import { Injectable } from '@angular/core';
import { ToolTipToggle } from '@com-delta-idp/mnx-sitewide-header-ui';
import { OauthAEMConfig } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { LoginFacadeHelperSuperService } from './login-facade-helper-super.service';
@Injectable({
  providedIn: 'root'
})
export class LoginFacadeHelperSuperSupportService extends LoginFacadeHelperSuperService {
  validateToolTipDisplay(
    loggedIn: boolean,
    authConfig: OauthAEMConfig
  ): boolean {
    const value =
      loggedIn &&
      this.mfaToolTipDisplayPages?.some((page) =>
        window.location.pathname.includes(page)
      ) &&
      this.hideAccountRecoveryTooltip === false &&
      authConfig.MFA_FLOW === true;
    return value;
  }

  updateToolTipToggle(partialUpdate: Partial<ToolTipToggle>): void {
    this.toolTipToggle$.next({
      ...this.toolTipToggle$.getValue(),
      ...partialUpdate
    });
  }
}
